export default {
  queue: false,
  genresList: null,
  status: "init",
  errors: [],
  errorCode: null,
  title: window.title
};
